export default __webpack_public_path__ + "static/media/cover.51ce3fa0.png";